// extracted by mini-css-extract-plugin
module.exports = {"title":"material-module__title___3VH8x","text":"material-module__text___2X30x","images":"material-module__images___2UKrw","root":"material-module__root___39JOs"};